import { Box } from "@similarweb/ui-components/foundations";

import BulkAddModal from "app/pages/sales-intelligence/common-components/modals/BulkAddModal/BulkAddModal";

import type { AppsIdentifiers } from "../types";
import { getBulkAddTextConfig, parseInputValue } from "../utils";

type AppIdentifierBulkAddProps = {
    appIdentifierType: AppsIdentifiers;
    onUpdate: (value: readonly string[]) => void;
};

const AppIdentifierBulkAdd: React.FC<AppIdentifierBulkAddProps> = ({ onUpdate, appIdentifierType }) => {
    const { header, text, counterText, placeholder, buttonText } = getBulkAddTextConfig(appIdentifierType);

    return (
        <Box marginY="24px 0">
            <BulkAddModal
                parseInputValue={parseInputValue}
                header={header}
                text={text}
                counterText={counterText}
                placeholder={placeholder}
                buttonText={buttonText}
                onAddValues={onUpdate}
            />
        </Box>
    );
};

export default AppIdentifierBulkAdd;
